import React, { Component } from 'react'
import { FaGithub, FaTwitter } from 'react-icons/lib/fa'
import { MdEmail } from 'react-icons/lib/md'
import styled from 'styled-components'

const Container = styled.div`
  a:first-child {
    margin: 0 !important;
  }
`

const UserIcon = styled.a`
  margin-left: 25px;
  color: white;
`

const iconStyle = {
  width: '30px',
  height: '30px'
}

class UserLinks extends Component {
  render() {
    return (
      <Container className="user-links">
        <UserIcon href={this.props.config.userLinks.github}>
          <FaGithub style={iconStyle} />
        </UserIcon>
        <UserIcon href={this.props.config.userLinks.email}>
          <MdEmail style={iconStyle} />
        </UserIcon>
      </Container>
    )
  }
}

export default UserLinks



// WEBPACK FOOTER //
// ./src/components/Accessories/UserLinks.jsx